import { shape, string, bool } from 'prop-types';

const notableClientType = shape({
    started_at: string, // Ex. "2017-04-01" or "2021-11-03T08:03:52.423Z"
    ended_at: string,
    interaction_description: string,
    enriched_details: shape({
        name: string.isRequired,
        description: string,
        industry: string,
        logo: string,
        in_fortune: bool
    }).isRequired
});

export default notableClientType;
